import { render, staticRenderFns } from "./Backgroundimage.vue?vue&type=template&id=ac71b67e&"
import script from "./Backgroundimage.vue?vue&type=script&lang=js&"
export * from "./Backgroundimage.vue?vue&type=script&lang=js&"
import style0 from "./Backgroundimage.vue?vue&type=style&index=0&id=ac71b67e&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac71b67e')) {
      api.createRecord('ac71b67e', component.options)
    } else {
      api.reload('ac71b67e', component.options)
    }
    module.hot.accept("./Backgroundimage.vue?vue&type=template&id=ac71b67e&", function () {
      api.rerender('ac71b67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/renovation/Backgroundimage.vue"
export default component.exports